import ConsultantReview from './ConsultantReview';

export default ConsultantReview;
